import {
  PostQuestionsAndAnswersScheduleScriptParams,
} from 'domain/usecases/private/booking-flow/health/post-questions-and-answers-schedule-script';
import {makePostQuestionsAndAnswersScheduleScript} from 'main/factories/usecases/private/booking-flow/remote-health-booking/get-questions-and-answers-schedule-script-factory';
import {EntryPointCodeEnum} from 'presentation/pages/private/booking/constants';
import {
  QueryParamsEnum,
} from 'presentation/constants';
import {QuestionsAndAnswersScheduleScriptProps} from './types';

async function questionsAndAnswersScheduleScript({
  message,
  locationName,
  restartConversation,
  locationType,
  stateCode,
}: QuestionsAndAnswersScheduleScriptProps) {
  const searchParams = new URLSearchParams(window.location.search);
  const specialtyCode = searchParams.get(QueryParamsEnum.SPECIALTY_CODE)
    ? Number(searchParams.get(QueryParamsEnum.SPECIALTY_CODE))
    : 3;
  const entryPointCode = Number(EntryPointCodeEnum.V2);

  const params: PostQuestionsAndAnswersScheduleScriptParams = {
    message,
    specialtyCode,
    stateCode,
    locationName,
    locationType,
    entryPointCode,
    restartConversation,
  };

  return makePostQuestionsAndAnswersScheduleScript().post(params);
}

export {
  questionsAndAnswersScheduleScript,
};
